module.exports = __webpack_public_path__ + "img/gmbbusiness-icon.476cbddd.png";